<template>
  <div class="custom-pagination-container">
    <div class="pagination-left">
      <slot name="footer-update"></slot>
      <slot name="footer-list">
        <span v-if="!countRight" class="text-muted">Записей: <b>{{ totalRows }}</b></span>
      </slot>
    </div>

    <div class="pagination-center">
      <slot name="footer-pagination">
        <b-pagination-nav
          v-if="useRouter"
          class="m-0 custom-pagination-nav"
          :link-gen="linkGen"
          :number-of-pages="numberOfPages"
          :per-page="perPage"
          :value="currentPage"
          @page-click="onPagination"
        />
        <b-pagination
          v-else
          class="m-0 custom-pagination-nav"
          :total-rows="totalRows"
          :per-page="perPage"
          :value="currentPage"
          @input="onPaginationInput"
        />
      </slot>
    </div>

    <div class="pagination-right">
      <slot name="count-right"></slot>
      <slot name="footer-per-page">
        <span class="text-muted">Показывать по:</span>
        <b-form-select
          class="custom-per-page-select"
          :value="perPage"
          :options="pageOptions"
          @change="onPerPageChange"
        />
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaginationFooter',
  props: {
    currentPage: { type: Number, default: 1 },
    totalRows: { type: Number, required: true },
    perPage: { type: Number, required: true },
    pageOptions: { type: Array, default: () => [10, 50, 100, 300, 500] },
    useRouter: { type: Boolean, default: false },
    countRight: { type: Boolean, default: false }
  },
  computed: {
    numberOfPages() {
      return Math.max(1, Math.ceil(this.totalRows / this.perPage));
    }
  },
  methods: {
    linkGen(pageNum) {
      return '#page/' + pageNum;
    },
    onPagination(e, page) {
      this.$emit('page-click', e, page);
    },
    onPaginationInput(page) {
      this.$emit('update:current-page', page);
      this.$emit('page-change', page);
    },
    onPerPageChange(newValue) {
      this.$emit('per-page-change', newValue);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/utilites/commonUi/PaginationFooter.vue